import { useState } from 'react';
import axios from 'axios';
import { X, FileText } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SampleModal = ({ product, onClose }) => {
  const [email, setEmail] = useState('');
  if (!product) return null;
  const open = () => window.open(product.sample_url, '_blank', 'noopener');
  const submit = (e) => {
    e.preventDefault();
    open();
    axios.post(`${API}/sample-requests`, { email, product_id: product.id }).catch(() => {});
    onClose();
  };
  const skip = () => { open(); onClose(); };
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="sample-modal">
      <div className="bg-white rounded-2xl w-full max-w-md p-7 relative">
        <button onClick={onClose} data-testid="sample-modal-close" className="absolute top-4 right-4 p-1 hover:bg-[#F5EFE9] rounded-lg"><X size={18} /></button>
        <FileText className="text-[#C5A059] mb-3" size={28} />
        <h3 className="font-display text-2xl text-[#1E1622] mb-2">Read a free sample</h3>
        <p className="text-sm text-[#1E1622]/60 mb-5">
          {product.guide_title ? <>Ten free pages from <em>{product.guide_title}</em>.</> : 'Ten free pages from the guide.'} Leave your email and we'll send you a short note with tips on choosing the right edition.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="sample-email-input"
            className="w-full p-3 border border-[#E6DAC5] rounded-xl focus:border-[#3B164C] focus:outline-none" />
          <button type="submit" data-testid="sample-submit-btn" className="btn-gold w-full text-sm">Open the sample</button>
        </form>
        <button onClick={skip} data-testid="sample-skip-btn" className="mt-4 w-full text-center text-sm text-[#1E1622]/50 hover:text-[#3B164C] transition-colors duration-200">Skip, just show me the sample</button>
      </div>
    </div>
  );
};
